import { inject } from '@angular/core';
import { type ResolveFn } from '@angular/router';
import { forkJoin } from 'rxjs';

import type { DropdownOption } from '@ui';
import { AddressSubmitService } from './address-submit.service';
import { CommonDataService } from '@shared/services/common-data.service';
import { isNullOrUndefined } from '@utils/predicates';
import { environment } from '@environments';

export interface AddressDataInitData {
  docTypes: { options: DropdownOption[]; preselectId: string | null };
  provinces: { options: DropdownOption[]; preselectId: string | null };
}

export const addressDataResolver: ResolveFn<AddressDataInitData> = () => {
  const submitService = inject(AddressSubmitService);
  const commonData = inject(CommonDataService);

  const savedData = commonData.getHolderData('addressData');
  const countryCode = isNullOrUndefined(savedData) ? environment.defaultCountry : savedData.countryCode;

  return forkJoin({
    docTypes: submitService.loadDocTypes(savedData?.documentTypeName),
    provinces: submitService.loadProvinces(countryCode, savedData?.provinceName)
  });
};
